"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
function default_1({ isEdit }) {
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    if (!maxWidth768)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)(components_1.SubHeaderGrid, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: functions_1.goBackOrMain }, { children: (0, jsx_runtime_1.jsx)(svgs_1.HeaderBackSvg, {}) })), t(isEdit ? '커미션 타입 수정' : '커미션 타입 만들기')] }));
}
exports.default = default_1;
2;
